export const EDITOR_TIMELINE_FPS = 30;

export type FrameSnapMode = 'nearest' | 'floor' | 'ceil';

function safeFps(fps: number) {
  return Number.isFinite(fps) && fps > 0 ? Math.round(fps) : EDITOR_TIMELINE_FPS;
}

export function frameDuration(fps = EDITOR_TIMELINE_FPS) {
  return 1 / safeFps(fps);
}

export function timeToFrame(time: number, fps = EDITOR_TIMELINE_FPS, mode: FrameSnapMode = 'nearest') {
  const value = Math.max(0, Number.isFinite(time) ? time : 0) * safeFps(fps);
  if (mode === 'floor') return Math.floor(value + 1e-7);
  if (mode === 'ceil') return Math.ceil(value - 1e-7);
  return Math.round(value);
}

export function frameToTime(frame: number, fps = EDITOR_TIMELINE_FPS) {
  return Math.max(0, Math.round(Number.isFinite(frame) ? frame : 0)) / safeFps(fps);
}

export function snapTimeToFrame(time: number, fps = EDITOR_TIMELINE_FPS, mode: FrameSnapMode = 'nearest') {
  return frameToTime(timeToFrame(time, fps, mode), fps);
}

export function stepTimeByFrames(time: number, frames: number, fps = EDITOR_TIMELINE_FPS) {
  return frameToTime(timeToFrame(time, fps) + Math.round(frames), fps);
}

export function formatFrameTimecode(time: number, fps = EDITOR_TIMELINE_FPS) {
  const rate = safeFps(fps);
  const totalFrames = timeToFrame(time, rate, 'floor');
  const frames = totalFrames % rate;
  const totalSeconds = Math.floor(totalFrames / rate);
  const seconds = totalSeconds % 60;
  const minutes = Math.floor(totalSeconds / 60) % 60;
  const hours = Math.floor(totalSeconds / 3600);
  return [hours, minutes, seconds, frames].map((value) => String(value).padStart(2, '0')).join(':');
}
